import React from 'react';
import { Dialog } from '@mui/material';
import useProfileEditorDialog from '../../hooks/useProfileEditorDialog';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { StyledDialogTitle } from '../styled/Dialog/StyledDialogTitle';
import { StyledDialogContent } from '../styled/Dialog/StyledDialogContent';
import { AdminUserAddresses } from '../admin/users/AdminUserAddresses';
import StyledTitle from '../styled/Dialog/StyledTitle';

const AdminUserAddressesEditorDialog: React.FC<{ open: boolean }> = (props) => {
    const profileDialog = useProfileEditorDialog();
    const { t } = useTranslation('admin', {
        keyPrefix: 'USERS.EDIT_ADDRESSES',
    });
    const handleFormSubmitClose = () => {
        profileDialog.setAddressDialogClosedWithSuccess(true);
        profileDialog.closeAllDialog();
    };

    const handleClose = () => {
        profileDialog.closeAllDialog();
    };

    if (!props.open) {
        return <></>;
    }

    return (
        <Dialog
            open={props.open}
            onClose={handleClose}
            maxWidth={'sm'}
            fullWidth
        >
            <StyledDialogTitle>
                <StyledTitle>
                    {t(
                        profileDialog.profileEditorStates.adminAddress.type.toUpperCase()
                    )}
                </StyledTitle>
                <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleClose} />
            </StyledDialogTitle>
            <StyledDialogContent>
                {profileDialog.profileDialogState.selectedUserId && (
                    <AdminUserAddresses
                        userId={profileDialog.profileDialogState.selectedUserId}
                        type={
                            profileDialog.profileEditorStates.adminAddress.type
                        }
                        submitSuccess={handleFormSubmitClose}
                    />
                )}
            </StyledDialogContent>
        </Dialog>
    );
};

export default AdminUserAddressesEditorDialog;
